<template>
  <div :class="modalVisible ? 'modalWrapper visible' : 'modalWrapper'">
    <a href="#" class="bt_modalClose" @click.prevent="closeModal"/>
    <div class="modal">
      <a href="#" class="bt_modalClose" @click.prevent="closeModal"><i class="fa fa-times"/></a>
      <div class="modalHeader">
        <h3>{{ title }}</h3>
      </div>
      <div class="modalContent">
        <slot/>
      </div>
      <div class="modalFooter">
        <a href="#" class="bt btG" @click.prevent="closeModal">{{$t('modal.close')}}</a>
        <!--        <a href="#" @click.prevent="this.storage.modal.callback" class="bt">Confirmar</a>-->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ModalComponent',
  props: {
    title: String
  },
  data() {
    return {
      modalVisible: false
    }
  },
  methods: {
    closeModal() {
      this.modalVisible = false
    },
    openModal() {
      this.modalVisible = true
    }
  }
})
</script>
